import { Component, OnInit, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-distributor-menu',
  templateUrl: './distributor-menu.component.html',
  standalone: true,
  imports: [RouterLink]
})
export class DistributorMenuComponent implements OnInit {

  constructor() { 
  }

  ngOnInit(): void {
  }

  @Input() currentArea = '';

}
